var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.707,11.293l-11-11c-0.391-0.39-1.023-0.39-1.414,0l-11,11c-0.39,0.391-0.39,1.024,0,1.414C0.481,12.895,0.735,13,1,13 h1.25c0.138,0,0.25,0.112,0.25,0.25V23c0,0.552,0.448,1,1,1h5.75c0.138,0,0.25-0.112,0.25-0.25V19c0-1.381,1.119-2.5,2.5-2.5 s2.5,1.119,2.5,2.5v4.75c0,0.138,0.112,0.25,0.25,0.25h5.75c0.552,0,1-0.448,1-1v-9.75c0-0.138,0.112-0.25,0.25-0.25H23 c0.552,0,1-0.448,1-1C24,11.735,23.894,11.48,23.707,11.293z M12,12c-1.381,0-2.5-1.119-2.5-2.5S10.619,7,12,7s2.5,1.119,2.5,2.5 S13.381,12,12,12z",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0a876ab353caae0b25d6cd75ca9c7941.svg";
export { ForwardRef as ReactComponent };